module.exports = __webpack_public_path__ + "static/media/Adeoluwa Akomolafe.bca54b31.jpeg";